module.exports = __webpack_public_path__ + "static/media/removeOff.b642f998.svg";